export default __webpack_public_path__ + "static/media/step6.6ea6c3b5.png";